/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Color_PrInputs */

const en_fc_cmp_color_pr = /** @type {(inputs: Fc_Cmp_Color_PrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lumetri Color, Color Mode (beta)`)
};

/**
* | output |
* | --- |
* | "Lumetri Color, Color Mode (beta)" |
*
* @param {Fc_Cmp_Color_PrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_color_pr = /** @type {((inputs?: Fc_Cmp_Color_PrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Color_PrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_color_pr(inputs)
});
export { fc_cmp_color_pr as "fc.cmp.color.pr" }